import React from "react";
import { RPCRequests } from "src/modules/communication-protobuf";
import debug from "src/modules/debug-logger";

import normalizeEvent from "../../../activity-log/normalizeEvent";

export default function useCamera({ dispatch, latestState, rpc, peerJid }) {
  const takeSnapshot = React.useCallback(async () => {
    if (latestState.current.camera.status !== "initial") return;
    try {
      dispatch({
        type: "TAKE_VIDEO_SNAPSHOT_REQUEST"
      });
      const { result, snapshot } = await rpc.call(
        RPCRequests.TakeVideoSnapshot.create(),
        peerJid
      );
      if (result === "FAILURE") {
        throw new Error("TakeVideoSnapshotRPCRequest result === FAILURE");
      }
      normalizeEvent(snapshot.event);
      const blob = new Blob([snapshot.data]);
      const mediaDataUrl = URL.createObjectURL(blob);
      dispatch({
        type: "TAKE_VIDEO_SNAPSHOT_SUCCESS",
        payload: {
          id: snapshot.event.id,
          mediaDataUrl,
          data: snapshot.data,
          eventType: snapshot.event.eventType,
          mediaRatio: snapshot.event.mediaRatio,
          fileName: snapshot.event.fileName,
          start: snapshot.event.start
        }
      });
    } catch (error) {
      debug.activityLog("takeSnapshot failed:", error);
      dispatch({ type: "TAKE_VIDEO_SNAPSHOT_FAILURE" });
    }
  }, [rpc, peerJid, dispatch, latestState]);

  return React.useMemo(
    () => ({
      takeSnapshot
    }),
    [takeSnapshot]
  );
}
